import React from 'react';
import { filterValue } from './filterValue';
import PropTypes from 'prop-types';
import getLabel from '../../translations/messages';
import { localeFormatter } from '../../functions/textFormatter';
import './DisabledSelectOutput.css';

const DisabledSelectOutput = ({ style, label, name, localize, resource }, context) => (
  <div className="DisabledSelectOutput" style={style}>
    <div className="output-label">{getLabel(context.locale, label)}</div>
    <select disabled>
      <option>{
        filterValue({
          resource,
          name,
          formatter: localeFormatter(context.locale)(localize),
        })
      }</option>
    </select>
  </div>
);

DisabledSelectOutput.contextTypes = {
  locale: PropTypes.string,
};

export default DisabledSelectOutput;



// WEBPACK FOOTER //
// ./src/main/components/output/DisabledSelectOutput.js